import {

  GET_CURRENCY_DEFINITIONS_SUCCESS,
  GET_CURRENCY_DEFINITIONS_SYNC,
  GET_CURRENCY_DEFINITIONS_SYNC_SUCCESS,
  ADD_CURRENCY_DEFINITION_SUCCESS,
  UPDATE_CURRENCY_DEFINITION_SUCCESS,
  DELETE_CURRENCY_DEFINITION_SUCCESS,
  CLIENT_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
  recordList: [], //Model Data ve Error
  error: {},
}

const currencyDefinition = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_CURRENCY_DEFINITIONS_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
      }

    case GET_CURRENCY_DEFINITIONS_SYNC:
      return {
        ...state,
        currencyLoading: true
      }

    case GET_CURRENCY_DEFINITIONS_SYNC_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
        currencyLoading: false
      }

    case ADD_CURRENCY_DEFINITION_SUCCESS:
      return {
        ...state,
        recordList: [...state.recordList, action.payload],
      }

    case UPDATE_CURRENCY_DEFINITION_SUCCESS:
      return {
        ...state,
        recordList: state.recordList.map(record =>
          record.guid.toString() === action.payload.guid.toString()
            ? { record, ...action.payload }
            : record
        ),
      }

    case DELETE_CURRENCY_DEFINITION_SUCCESS:
      return {
        ...state,
        recordList: state.recordList.filter(
          record => record.guid.toString() !== action.payload.toString()
        ),
      }

    case CLIENT_API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        currencyLoading: false
      }

    default:

      return state

  }
}

export default currencyDefinition